import React from 'react';
import DataContainer from 'Components/UI/DataContainer';
import { useRightColumnContext } from 'Context/RightColumnContext';
import ContentLoading from 'Components/ComponentLibrary/Molecules/ContentLoading';
import Content from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/ScenarioDetailsPicker/components/Content';

const Container = () => {
  const { rightColumnCollectionLoading, rightColumnCollectionError } = useRightColumnContext();

  return (
    <DataContainer
      component={Content}
      loading={rightColumnCollectionLoading}
      loadingError={rightColumnCollectionError}
      skeleton={ContentLoading}
    />
  );
};

export default Container;
